<template>
  <div>
    <div class="alert alert-info" role="alert">
      <h4 class="alert-heading">{{translate('app.datafile-titolo')}}</h4>
      <p v-html="translate('app.datafile-testo-intestazione',0,[providerName])">
        {{(confUpload.extensions || []).join(',')}}</p>
      <hr>
      <div class="mb-0" v-html="translate('app.datafile-testo-info')">

<!--        <p>L'importazione avverrà in due fasi:</p>-->
<!--        <ul>-->
<!--          <li>la lettura del file e check degli errori</li>-->
<!--          <li>salvataggio del file importato</li>-->
<!--        </ul>-->

      </div>
    </div>
    <div v-if="uploadEnabled && status!=='loading'" class="panel panel-default">
<!--      <div>Seleziona file da importare</div>-->
      <!--            <w-upload-ajax :c-conf="confUpload" v-on:success="uploadsuccess"></w-upload-ajax>-->
      <div class="col-12">
        <v-edit :c-conf="_uploadConf()"></v-edit>
      </div>

    </div>
    <div v-if="progressEnabled">
      <div class="progress h--40 mb-3">
<!--        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"-->
<!--             :style="'width:'+progressValue+'%'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progressValue}}%-->
<!--        </div>-->
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
             :style="'width:100%'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
          <div v-if="status==='loading'">
            Lettura file e check degli errori ...&nbsp;
          </div>
          <div v-if="status==='saving'">
            Salvataggio del file importato ...
          </div>
        </div>
      </div>
      <!--            <div class="shadow w-full bg-grey-light">-->
      <!--                <div class="bg-blue-500 text-xs leading-none py-1 text-center text-white" :style="'width:'+progressValue+'%'">{{progressValue}}%</div>-->
      <!--            </div>-->
      <!--            -->
      <!--            <div class="progress">-->
      <!--                <div class="progress-bar progress-bar-striped" :style="'width:'+progressValue+'%'"></div>-->
      <!--            </div>-->
    </div>
    <div v-if="saveEnabled && status!=='saving'">
      <div>File caricato e controllato</div>
      <v-edit :c-conf="_saveConf()"></v-edit>
      <v-list :c-conf="_listConf()" inline-template >
          <div class="row">
              <!-- start:col: -->
              <div class="col-12 mb-1 p-0">

                  <!-- start:portlet -->

                  <c-loading v-if="loading" :error-msg="errorMsg"></c-loading>
                  <div v-else class="portlet">
                      <div class="portlet-header border-bottom" :class="headerClass">
                          <span v-show="viewTitle">{{viewTitle}}</span>
                          <!-- options and pagination -->
                          <div class="row justify-content-end">

                              <div v-if="paginator" class="col-12 col-md-6 mt-1 mb-2">
                                  <!-- v-bind:c-route-conf="routeConf" -->
                                  <c-paginator v-if="widgets.length > 0" v-show="pagination"
                                               v-bind:c-pagination="pagination" v-bind:c-route="route"></c-paginator>
                              </div>
                              <div class="col-12 col-md-6 mt-1 mb-2" v-show="collectionActionsName.length">
                                  <template v-for="name in collectionActionsName">
                                      <component v-bind:is="name" v-bind:c-conf="collectionActions[name]" :key="name"></component>
                                  </template>
                              </div>

                          </div>
                          <div v-show="multiSheets">
                              <span>Mostra sheet:</span>
                              <w-select :c-conf="selectSheetConf"></w-select>
                          </div>
                          <!-- /options and pagination -->

                          <!-- header -->
                          <!-- portlet : header -->
                          <!-- /portlet : header -->

                          <!-- /header -->
                      </div>
                      <div class="portlet-body pb-0">
                          <div class="container-fluid py-1">


                              <div class="table-responsive" style="white-space:nowrap;" :class="modelName">
                                  <table class="table table-framed table-striped table-bordered">
                                      <thead>
                                      <tr v-if="widgets.length > 0">
                                          <th v-if="needSelection" class="text-gray-500 w--50">
                                              <label class="form-checkbox form-checkbox-primary float-start">
                                                  <input c-row-check-all v-on:change="selectAllRows"
                                                         class="checkall" type="checkbox">
                                                  <i></i>
                                              </label>
                                          </th>
                                          <th v-if="recordActionsName.length"></th>
                                          <template v-for="key in keys">
                                              <th  v-if="!isHiddenField(key)" :key="key"
                                                   class="text-gray-500 font-weight-normal fs--14" :class="'field-'+key">
                                                  <action-order v-if="orderFields[key]"
                                                                v-bind:c-conf="getOrderConf(key)"></action-order>
                                                  <span style="cursor:default"
                                                        class="btn btn-default btn-xs mr-1 text-gray-500 font-weight-normal fs--14"
                                                        v-else>{{key+'.label' | translate(langContext) }}</span>
                                                  <button v-if="hasHelp(key)"
                                                          type="button"
                                                          class="btn-xs btn-squared btn-light"
                                                          data-trigger="focus"
                                                          data-container="body"
                                                          data-toggle="popover"
                                                          data-placement="top"
                                                          :data-content="hasHelp(key)">
                                                      <i class="fi fi-round-question-full text-red-700"></i>
                                                  </button>

                                              </th>
                                          </template>

                                      </tr>
                                      <tr v-if="widgets.length == 0">
                                          <th v-show="recordActionsName.length" class="text-gray-500 w--50">
                                              {{"app.nessun-elemento" | translate }}
                                          </th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <!-- product -->
                                      <tr v-for="(row,index) in widgets" :key="index">
                                          <th v-if="needSelection">

                                              <label
                                                  class="form-checkbox form-checkbox-primary float-start">
                                                  <input c-row-check type="checkbox">
                                                  <i></i>
                                              </label>


                                          </th>
                                          <th v-show="recordActionsName.length">
                                              <div class="btn-group" role="group">
                                                  <template v-for="(action,name) in recordActions[index]">
                                                      <v-action :c-action="action" :key="name"></v-action>
                                                  </template>
                                              </div>

                                          </th>
                                          <template v-for="(widget, key) in row">
                                              <td  v-if="!isHiddenField(key)" :class="tdClass(index, key)" :key="key">
                                                  <v-widget :c-widget="widget" :key="key"></v-widget>
                                                  <div v-if="hasError(index,key)">
                                                      <hr>
                                                      <small>(foglio = {{value[index]['datafile_sheet']}})</small>
                                                      <small>(riga = {{value[index]['row']}})</small>
                                                  </div>
                                                  <action-base v-if="canEdit && hasError(index,key)" :c-conf="editErrorConf(index,key)"></action-base>
                                              </td>
                                          </template>

                                          <template v-for="(widget, key) in row" >
                                              <v-widget :c-widget="widget" :key="key" v-if="isHiddenField(key)"></v-widget>
                                          </template>
                                      </tr>
                                      </tbody>

                                      <tfoot v-if="hasFooter">
                                      <tr v-if="widgets.length > 0">
                                          <th v-if="needSelection" class="text-gray-500 w--50">

                                          </th>
                                          <th v-show="recordActionsName.length"></th>
                                          <template v-for="key in keys">
                                              <th  v-if="!isHiddenField(key)" :key="key"
                                                   class="text-gray-500 font-weight-normal fs--14">
                                                  <action-order v-if="orderFields[key]"
                                                                v-bind:c-conf="getOrderConf(key)"></action-order>
                                                  <span style="cursor:default"
                                                        class="btn btn-default btn-xs mr-1 text-gray-500 font-weight-normal fs--14"
                                                        v-else>{{key+'.label' | translate(langContext) }}</span>
                                                  <button v-if="hasHelp(key)"
                                                          type="button"
                                                          class="btn-xs btn-squared btn-light"
                                                          data-trigger="focus"
                                                          data-container="body"
                                                          data-toggle="popover"
                                                          data-placement="top"
                                                          :data-content="hasHelp(key)">
                                                      <i class="fi fi-round-question-full text-red-700"></i>
                                                  </button>

                                              </th>
                                          </template>

                                      </tr>
                                      </tfoot>


                                  </table>
                              </div>


                          </div>
                          <!-- end:portlet -->
                      </div>
                  </div>

              </div>
              <!-- end:col: -->

          </div>
      </v-list>

    </div>
  </div>
</template>

<script>
import cComponent from '../misc/cComponent'
import {cImportMixin} from 'crud-vue-core'

export default {
  name: 'c-import',
  props: ['cProviderName'],
  extends: cComponent,
  mixins: [cImportMixin]
}

</script>

<style scoped>

</style>
